/**
 * main.tsx
 * ─────────────────────────────────────────────────────────────────────────────
 * src/main.tsx
 *
 * App entry point. Mounts the React app into the DOM.
 *
 * IMPORTANT - providers live where they belong:
 *   · AuthProvider    → App.tsx (wraps Router)
 *   · UserProvider    → AppShell.tsx (wraps pillars, requires userId)
 *   · BrowserRouter   → here (if react-router-dom is used anywhere)
 *
 * Do NOT add AuthProvider or UserProvider here — it creates duplicates
 * that cause auth token conflicts and blank screens on refresh.
 *
 * FONTS - self-hosted, deliberately.
 *   Lora    = --sys-font-display (italic is used by .titl and
 *             .emotional-core, so the italic file is required)
 *   DM Sans = --sys-font-body
 *   Variable versions cover weights 400 to 700 in one file each.
 *   These were previously fetched from Google in two places: a <link>
 *   in index.html and an @import in lukaduka-shared.css. Both were
 *   render-blocking, which is what caused the white screen on a cold
 *   open, and both sent every user's IP address to Google.
 *   Do not reintroduce either.
 * ─────────────────────────────────────────────────────────────────────────────
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource-variable/lora'
import '@fontsource-variable/lora/wght-italic.css'
import '@fontsource-variable/dm-sans'
import '@/styles/lukaduka-shared.css'
import App from './app/App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)